import Image from 'next/image';
import {FaExternalLinkAlt} from 'react-icons/fa';
import {LOGO_IMAGE_PATH_DEFAULT} from '../../../../../config/constants/img';

export const RegisterHeader = () => {
  return (
    <div>
      <div className="pc:hidden">
        <MobileRegisterHeader />
      </div>
      <div className="hidden pc:block">
        <PcRegisterHeader />
      </div>
    </div>
  );
};

const PcRegisterHeader = () => {
  return (
    <div className="text-base">
      <div className="flex h-64 items-center justify-between bg-primary-1 px-16">
        <a href={undefined}>
          <Image
            src={LOGO_IMAGE_PATH_DEFAULT}
            alt="logo"
            width={124}
            height={29}
          />
        </a>
        <div className="text-md text-white-1">
          外資・日系トップ企業を目指す学生のための就職活動サイト「外資就活ドットコム」
        </div>
        <a
          href="https://biz.gaishishukatsu.com/"
          className="text-white-1 hover:underline hover:decoration-white-1"
        >
          <div className="flex">
            <span className="px-4">採用担当者様はこちら</span>
            {/** Mdにないアイコンのため、Faを使用 */}
            <FaExternalLinkAlt size={16} />
          </div>
        </a>
      </div>
    </div>
  );
};

const MobileRegisterHeader = () => {
  return (
    <div className={'bg-primary-1 flex justify-center p-16'}>
      <div className="flex pc:hover:opacity-80 pc:hover:duration-300 pc:hover:ease-in-out">
        <Image
          src={LOGO_IMAGE_PATH_DEFAULT}
          width="84"
          height="19"
          alt="外資就活ドットコム"
        />
      </div>
      <div className="flex items-center" />
    </div>
  );
};
